export default __webpack_public_path__ + "images/976b8b5c2ec8dd04cf2b711f0b9047b6.jpg";